import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1146.61551 -0.0116195329L1146.61551 232.379039 1523.43696 232.379039 232.390658 1523.30915 232.390658 1146.60389 0 1146.60389 0 1920 773.628502 1920 773.628502 1687.60934 396.690854 1687.60934 1687.73716 396.679234 1687.73716 773.500687 1920.01162 773.500687 1920.01162 -0.0116195329z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFullScreenSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconFullScreenSolid, _Component);

  var _super = _createSuper(IconFullScreenSolid);

  function IconFullScreenSolid() {
    _classCallCheck(this, IconFullScreenSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconFullScreenSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFullScreen",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFullScreenSolid.displayName = "IconFullScreenSolid";
  return IconFullScreenSolid;
}(Component);

IconFullScreenSolid.glyphName = 'full-screen';
IconFullScreenSolid.variant = 'Solid';
IconFullScreenSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFullScreenSolid;
export { IconFullScreenSolid };